import { AppController } from 'app/controllers';
import { LoadMoreViewModel } from '../components/LoadMoreViewModel';
import { CampaignData } from 'common/types/models/campaign';

const initialPage = 0;
const defaultLimit = 7;

export class UserInnerPageViewModel {
    private readonly _usedId: string;
    private _loadMoreModel = new LoadMoreViewModel<CampaignData>();

    constructor(userId: string) {
        this._usedId = userId;

        this._loadMoreModel.initialize(
            initialPage,
            defaultLimit,
            (offset, limit) => AppController.Instance.Campaigns.getCampaignsByUser(this._usedId, offset, limit),
        );
    }

    get userCampaigns() { return this._loadMoreModel.items; }
    get isLoading() { return this._loadMoreModel.isLoading; }
    get hasMore() { return this._loadMoreModel.hasMore; }

    public handleClickLoadMore = () => { this._loadMoreModel.loadMore(); };
}
